var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46597",
    "data-name": "Group 46597",
    transform: "translate(-946.5 -386.5)",
    opacity: 0.574
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39787",
    "data-name": "Ellipse 39787",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(947.5 387.5)",
    fill: "none",
    stroke: "#252533",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: 9
  }), /*#__PURE__*/React.createElement("path", {
    id: "a75d38c6bce68638f33a3075e9af1ed3",
    d: "M34,22V46M46,34H22",
    transform: "translate(953.5 393.5)",
    fill: "none",
    stroke: "#252533",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToStar);
export default __webpack_public_path__ + "static/media/add-to-star.9a6895199f5e975dafb475c9678c6667.svg";
export { ForwardRef as ReactComponent };